import React from 'react';
import { Grid, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';
import { translate } from 'utils';

const SkeletonNoTableResults = ({ error }) => (
  <Grid alignItems="center" container direction="column" justify="center">
    <Grid item>
      <Typography align="center" style={{ marginBottom: '4rem' }}>{translate(error)}</Typography>
    </Grid>
    <Grid item>
      <img alt={translate(error)} src="/assets/images/no-results.png" />
    </Grid>
  </Grid>
);

SkeletonNoTableResults.propTypes = {
  error: PropTypes.string
};

SkeletonNoTableResults.defaultProps = {
  error: 'errors.noTableResults'
};

export default SkeletonNoTableResults;